import React from 'react'

function PlansListDetails() {
  return (
    <div>PlansListDetails</div>
  )
}

export default PlansListDetails